// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-1j3l5","context":"context-3URQ3","info":"info-1g5VV","text":"text-3H4nm","warning":"warning-1MPtO"};